import LogoFooterFarmacia from "../../assets/LogoFooterFarmacia.svg"
import facebook from "../../assets/facebook.svg"
import twitter from "../../assets/twitter.svg"
import youtube from "../../assets/youtube.svg"
import instagram from "../../assets/instagram.svg"
import styles from "./Footer.module.css"
import { useTranslation } from 'react-i18next';


export default function Footer() {

  const { t, i18n } = useTranslation();

  return (
    <footer className={styles.containerFooter}>
      <div className={styles.footeer}>
        <div className={styles.logosTextosDiv}>
          <div className={styles.logos}>
            <img className={styles.Footerlogo} src={LogoFooterFarmacia} alt="logo" />
          </div>
          <div className={styles.textos}>
            <div className={styles.sobre}>
              <h3>{t('footer.about')}</h3>
              <a>{t('footer.policy')}</a>
              <a>{t('footer.privacy')}</a>
              <a>{t('footer.termsConditions')}</a>
              <a>{t('footer.howItWorks')}</a>
            </div>

            <div className={styles.ajuda}>
              <h3>{t('footer.help')}</h3>
              <a>{t('footer.frequentQuestions')}</a>
              <a>{t('footer.contact')}</a>
              <a>{t('footer.createStore')}</a>
              <a>{t('footer.productProblem')}</a>
            </div>

            <div className={styles.links}>
              <h3>{t('footer.links')}</h3>
              <a>{t('footer.accessAccount')}</a>
              <a>{t('footer.signIn')}</a>
              <a>{t('footer.searchPage')}</a>
              <a>{t('footer.blog')}</a>
            </div>
          </div>
        </div>
        <div className={styles.sociasDiv}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            <div className={styles.sociais}>
              <div className={styles.redes}>
                <a href="facebook.com"><img src={facebook} alt="facebook" /></a>
              </div>

              <div className={styles.redes}>
                <a href="twitter.com"><img src={twitter} alt="twitter" /></a>
              </div>

              <div className={styles.redes}>
                <a href="youtube.com"><img src={youtube} alt="youtube" /></a>
              </div>

              <div className={styles.redes}>
                <a href="instagram.com"><img src={instagram} alt="instagram.svg" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
